import { Button } from '@material-ui/core'
import { signIn } from 'aws-amplify/auth'
import * as React from 'react'
import { useHistory } from 'react-router-dom'
import validator from 'validator'

import { SectionSubTitle } from '../../components/atoms/SectionTittle'
import { TextInputEx } from '../../components/atoms/TextInputEx'
import { getSelf } from '../../services/user-services'
import { containerStyles } from '../../styles/ContainerStyles'
import { invoke } from '../../utils/helper'
import { showMessage } from '../../utils/notification'

// TODO: link to reset password
export const Login: React.FC = () => {

    const [email, setEmail] = React.useState<string>('')
    const [password, setPassword] = React.useState<string>('')

    const history = useHistory()
    const styles = containerStyles()

    const logIn = async () => {
        await invoke(async () => {
            try {
                if (!validator.isEmail(email)) {
                    showMessage('Brug din registrerede e-mail', 'error')
                    return
                }

                const result = await signIn({ username: email, password })

                if (result) {
                    // Small delay to ensure token is fully ready in v6
                    // eslint-disable-next-line no-promise-executor-return
                    await new Promise((resolve) => setTimeout(resolve, 500))
                    
                    try {
                        const self = await getSelf()
                        if (self) {
                            history.push('/')
                        }
                    } catch (e: any) {
                        // User exists in Cognito but hasn't finalized → redirect to finalize
                        console.warn('getSelf failed after login, redirecting to finalize', e)
                        history.push({
                            pathname: '/afslutte',
                            state: { email, password }
                        })
                    }
                }
            } catch (error) {
                if ((error as any).code === 'UserNotConfirmedException') {
                    history.push({
                        pathname: '/bekraeftet',
                        state: {
                            email, password,
                        } 
                    })
                } else if ((error as any).code === 'NotAuthorizedException') {
                    showMessage((error as any).message, 'error')
                } else {
                    throw error
                }
            }
        }, {
            operation: 'Logger ind',
        })
    }

    const handleKeyPress = (key: string, event: React.KeyboardEvent) => {
        if (key === 'Enter') {
            event.preventDefault()
            if (validator.isEmail(email) && password.length >= 6) {
                logIn()
            }
        }
    }

    return (
        <div className={styles.authContainer}>

            <div className={styles.innerAuthContainer}>
                <div>
                    <SectionSubTitle text="Log Ind"/>
                </div>
                <div className={styles.loginInputs}>
                    <TextInputEx
                        error={!validator.isEmail(email)}
                        fullWidth
                        value={email}
                        onChange={setEmail}
                        onKeyPress={handleKeyPress}
                        label="Email" />
                    <TextInputEx
                        fullWidth
                        value={password}
                        label="Password"
                        onChange={setPassword}
                        onKeyPress={handleKeyPress}
                        type="password"/>
                    <span
                        style={{ color: 'white', cursor: 'pointer', margin: 4 }}
                        onClick={() => history.push('/gendan-adgangskode')}>Nulstil kodeord
                    </span>
                </div>
                <div>
                    <Button
                        disabled={!validator.isEmail(email) || password.length < 6}
                        onClick={logIn}
                        className="btn-auth">
                        Log Ind
                    </Button>
                </div>
            </div>

        </div>
    )
}
